import type { CreateSearchBannerOptions } from '../models/CreateSearchBannerOptions';
import { startFeature } from './startFeature';
/**
 * Create a Brilliant search button in a banner.
 */
export function createSearchBanner(options: CreateSearchBannerOptions): void {
    const { searchText, parent } = options;
    if (!searchText) {
        throw new Error(
            'Brilliant: searchText is required to create a the search banner.'
        );
    }
    const container = document.createElement('div');
    container.style.display = 'flex';
    container.style.width = '100%';
    container.style.justifyContent = 'center';
    container.innerHTML = `
<div style="color: #5670A1; display: flex; flex-direction: column; gap: 16px; align-items: center;font-family: Outfit; width: 100%;">
    <div style="display: flex; align-items: center; gap: 8px; justify-content: center; width: 100%;">
        <svg xmlns="http://www.w3.org/2000/svg" width="8" height="8" viewBox="0 0 8 8" fill="none">
            <path d="M3.99883 0C2.85631 0 1.89493 0.387809 1.13789 1.15414C0.38317 1.91814 0 2.87489 0 3.99884C0 5.12279 0.38317 6.07954 1.13789 6.84355C1.89493 7.60988 2.85631 7.99769 3.99883 7.99769C5.14136 7.99769 6.15384 7.60988 6.8923 6.84123C7.62612 6.07722 8 5.12047 8 3.99884C8 2.87722 7.62844 1.92047 6.8923 1.15646C6.15384 0.387811 5.18083 0 3.99883 0Z" fill="url(#paint0_linear_4086_11383)"/>
            <defs>
                <linearGradient id="paint0_linear_4086_11383" x1="14.3222" y1="13.3432" x2="-2.42478" y2="4.69613" gradientUnits="userSpaceOnUse">
                    <stop offset="0.471102" stop-color="#F698D1"/>
                    <stop offset="0.677515" stop-color="#C27EC7"/>
                </linearGradient>
            </defs>
        </svg>
        ¿No encuentras lo que buscas?, ¡Brilliant está preparado para encontrar tu producto ideal!
    </div>
    <button type="button" style="display: inline-flex; font-family: Outfit; cursor: pointer; color: white; align-items: center; gap: 10px; background: linear-gradient(180deg, rgba(216, 178, 212, 0.80) 17.71%, rgba(205, 157, 200, 0.80) 86.46%);border: none; border-radius: 30px; padding: 0 20px; height: 48px; outline: none;">
        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
            <path d="M9.76823 4.62192C9.59529 4.54331 9.45668 4.40471 9.37807 4.23177L7.71529 0.573634C7.43615 -0.040477 6.56385 -0.0404778 6.28471 0.573633L4.62192 4.23177C4.54331 4.40471 4.40471 4.54331 4.23177 4.62192L0.573634 6.28471C-0.0404772 6.56385 -0.0404781 7.43615 0.573633 7.71529L4.23177 9.37808C4.40471 9.45669 4.54331 9.59529 4.62192 9.76823L6.28471 13.4264C6.56385 14.0405 7.43615 14.0405 7.71529 13.4264L9.37807 9.76823C9.45668 9.59529 9.59529 9.45669 9.76823 9.37808L13.4264 7.71529C14.0405 7.43615 14.0405 6.56385 13.4264 6.28471L9.76823 4.62192Z" fill="white"/>
        </svg>
        <span>Búsqueda inteligente</span>
    </button>
</div>
`;
    container
        .querySelector('button')
        ?.addEventListener('click', () =>
            startFeature({ featureType: 'product-search-by-text', searchText })
        );
    parent.appendChild(container);
}
